import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import { useNavigate } from "react-router-dom";
import { useRouting } from "JS/React/Hooks/Routes";

import { AppHeader } from "JS/React/Components/AppHeader";

import { useUserHistory } from "JS/React/Hooks/UserHistory";
import { AppButton } from "JS/React/Components/AppButton";
import { OldUser, User } from "JS/Models";
import { AppDivider } from "JS/React/Components/AppDivider";

const StyledRoot = styled("div")({
    height: "100vh",
});

const StyledList = styled("div")({
    flexGrow: 1,
    paddingBottom: "10%",
});

const StyledButton = styled(AppButton)({
    position: "fixed",
    bottom: "3%",
    right: "5%",
    left: "5%",
    alignItems: "center",
    justifyContent: "center",
    width: "90%",
});

const StyledBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    color: theme.palette.common.black,
}));

const StyledListItem1 = styled(ListItem)(({ theme }) => ({
    paddingBottom: "0px",
    color: theme.palette.common.black,
}));

const StyledListItem2 = styled(ListItem)(({ theme }) => ({
    paddingTop: "0px",
    paddingBottom: "0px",
    color: theme.palette.common.black,
}));

export const UserHistory = () => {
    const { history: userHistory } = useUserHistory();
    const [filteredHistory, setFilteredHistory] = useState(userHistory || []);

    const navigate = useNavigate();
    const { linkProvider } = useRouting();
    const { clearData } = useUserHistory();
    const clearHistory = () => {
        clearData();
    };
    const userClick = (user: OldUser) =>
        navigate(
            linkProvider.react.login(userHistory.indexOf(user).toString()),
            { replace: true },
        );

    useEffect(() => {
        if (userHistory?.length) {
            const uniqueHistory = userHistory.reduce((acc, curr) => {
                if (!acc.some((item) => item.member_id === curr.member_id)) {
                    acc.push(curr);
                }
                return acc;
            }, []);
            setFilteredHistory(uniqueHistory);
        }
    }, [userHistory]);

    return (
        <StyledRoot>
            <StyledList>
                <StyledBox>
                    <AppHeader
                        title={"User History"}
                        canGoBack
                        searchable={false}
                        onBackClick={() => {
                            navigate(linkProvider.react.login());
                        }}
                    />
                </StyledBox>

                {filteredHistory &&
                    filteredHistory.map((a) => (
                        <Box key={a.member_id}>
                            <StyledListItem1 onClick={() => userClick(a)}>
                                <ListItemText
                                    primary={a.first_name + " " + a.last_name}
                                />
                            </StyledListItem1>
                            <StyledListItem2>
                                <ListItemText primary={a.member_id} />
                            </StyledListItem2>
                            <AppDivider />
                        </Box>
                    ))}
            </StyledList>

            <StyledButton
                onClick={clearHistory}
                buttonVariant="primary-filled"
            >
                Clear History
            </StyledButton>
        </StyledRoot>
    );
};
